import React, { useRef } from 'react';
import { Card, CardContent, Button, Grid } from '@material-ui/core';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import ArticleList from '../../organisms/ArticleList';
import DecryptageEditor from '../../organisms/DecryptageEditor';
import PepiteEditor from '../../organisms/PepiteEditor';
import AtlanticoLightEditor from '../../organisms/AtlanticoLightEditor';
import PodcastEditor from '../../organisms/PodcastEditor';
import VideoEditor from '../../organisms/VideoEditor';
import DossierEditor from '../../organisms/DossierEditor';
import Article from '../../organisms/Article';
import RDVEditor from '../../organisms/RDVEditor';
import { Role, useAuthentication } from '../../contexts/Authentication';
import ArticleDatePicker from '../../atoms/Dates/ArticleDatePicker';
import ArticleRemove from '../../atoms/ArticleRemove';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column'
  },
  grid: {
    display: 'flex',
    flexDirection: "column",
    height: 'calc(90vh)',
    width: 'auto',
    marginTop: 10
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-around',
    flex: 1
  }
}));


const getAllowedTypes = (roles: Role[] | null = null) => {
  const types = [
    {
      name: "Décryptage",
      collection_name: "decryptage",
      roles: [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior],
      editor: DecryptageEditor
    },
    {
      name: "RDV",
      collection_name: "rdv",
      roles: [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior],
      editor: RDVEditor
    },
    {
      name: "Pépite",
      collection_name: "pepite",
      roles: [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior],
      editor: PepiteEditor
    },
    {
      name: "Atlantico Light",
      collection_name: "atlantico-light",
      roles: [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior],
      editor: AtlanticoLightEditor
    },
    {
      name: "Podcast",
      collection_name: "podcast",
      roles: [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior],
      editor: PodcastEditor
    },
    {
      name: "Vidéo",
      collection_name: "video",
      roles: [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior],
      editor: VideoEditor
    },
    {
      name: "Dossier",
      collection_name: "dossier",
      roles: [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior],
      editor: DossierEditor
    },
  ];
  if (roles === null) {
    return types
  } else {
    return types.filter(e => roles.some(r => e.roles.includes(r))) 
  }
}

const Articles = () => {
  const history = useHistory();
  const classes = useStyles();
  const auth = useAuthentication();
  const update_list = useRef<() => void>(() => {});
  const { path, url } = useRouteMatch();

  return (
  <div className={classes.container}>
    <Switch>
      <Route exact path={path}>
        <div className={classes.container}>
          <Card>
            <CardContent className={classes.buttons}>
                {getAllowedTypes(auth.role).map((e, i) => (
                  <Button key={i} size="large" variant="outlined" onClick={() => {
                    history.push(`${url}/create/${e.collection_name}`)
                  }}>{e.name}</Button>
                ))}
            </CardContent>
          </Card>
          <div className={classes.grid}>
            <ArticleList update={update_list} collection_name={"all"} action={(article) => (
              <div style={{display: 'flex', flex: 1}}>
                <Button onClick={() => {
                  history.push(`${url}/edit/${article.type}/${article.data.slug}/edit`)
                }}>{getAllowedTypes(auth.role).map(e => e.collection_name).includes(article.type) ? "Modifier" : "Proposé une révision"}</Button>
                { getAllowedTypes(auth.role).map(e => e.collection_name).includes(article.type) &&
                  <ArticleDatePicker article={article.data} defaultValue={article.data.publish_date} articleId={article.data.id} articleType={article.type}/>
                }
                {auth.role.some(e => [Role.Administrateur].includes(e)) && <ArticleRemove collection={article.type} id={article.data.id} onRemove={update_list.current}/>}
              </div>)
            } />
          </div>
        </div>
      </Route>
      {getAllowedTypes().map((e, i) => (
        <Route key={i} path={[`${path}/:action/${e.collection_name}/:slug`, `${path}/:action/${e.collection_name}`]}>
          <div>
            <Grid container spacing={3} style={{flexGrow: 1}} direction="column">
              <Grid item xs={5} style={{margin: 'auto'}}>
                <Card style={{display: 'flex', flex: 1}}>
                  <CardContent style={{display: 'flex', flex: 1}}>
                    <h2>Vous êtes en train de rédiger un(e) {e.name.toLowerCase()}</h2>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Article editor={e.editor} collection={e.collection_name}/>
              </Grid>
            </Grid>
          </div>
        </Route>
      ))}
    </Switch>
  </div>);
}

export default Articles;